import styled from 'styled-components'

export const AddressGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 20px;
  margin: 0 0 40px;

  > * {
    &:last-child {
      grid-column: 1 / 3;
    }
  }
`
